(function () {
  const slideUp = (element, duration = 300) => {
    if (!element) return;
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = "0";
    });

    setTimeout(() => {
      element.classList.add("collapsible-content__answer--closed");
      element.style.removeProperty("display");
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const slideDown = (element, duration = 300) => {
    if (!element) return;

    element.classList.remove("collapsible-content__answer--closed");
    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;

    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const toggleCollapsible = (event, toggles) => {
    if (!toggles) return;

    const answer = event.currentTarget.querySelector(
      ".collapsible-content__answer"
    );
    const activeItem = Array.from(toggles).find((item) =>
      item.classList.contains("active")
    );

    if (event.currentTarget !== activeItem) {
      if (activeItem) {
        activeItem.classList.remove("active");
        const activeAnswer = activeItem.querySelector(
          ".collapsible-content__answer"
        );
        if (activeAnswer) slideUp(activeAnswer);
      }
      event.currentTarget.classList.add("active");
      slideDown(answer);
    } else {
      event.currentTarget.classList.remove("active");
      slideUp(answer);
    }
  };

  const initLoadMore = (section) => {
    if (!section) return;

    const loadMoreRoot = section.querySelector(
      ".collapsible-content--has-load-more"
    );
    if (!loadMoreRoot) return;

    const buttonWrapper = loadMoreRoot.querySelector(
      ".collapsible-content__load-more-button-wrapper"
    );
    if (!buttonWrapper) return;

    const showMoreBtn = buttonWrapper.querySelector(".collapsible-content__show--more");
    const showLessBtn = buttonWrapper.querySelector(".collapsible-content__show--less");
    if (!showMoreBtn || !showLessBtn) return;

    const allItems = Array.from(
      loadMoreRoot.querySelectorAll(".collapsible-content__item")
    );
    const pageSize = parseInt(
      loadMoreRoot.dataset.collapsibleInitialCount || "4",
      10
    );

    if (!allItems.length || allItems.length <= pageSize) {
      buttonWrapper.style.display = "none";
      return;
    }

    const setExpandedState = (expanded) => {
      allItems.forEach((item, index) => {
        if (!expanded && index >= pageSize) {
          item.classList.add("collapsible-content__item--hidden-until-load");
        } else {
          item.classList.remove("collapsible-content__item--hidden-until-load");
        }
      });

      if (expanded) {
        showMoreBtn.classList.add("collapsible-content__show--hidden");
        showLessBtn.classList.remove("collapsible-content__show--hidden");
      } else {
        showMoreBtn.classList.remove("collapsible-content__show--hidden");
        showLessBtn.classList.add("collapsible-content__show--hidden");
      }
    };

    setExpandedState(false);

    showMoreBtn.addEventListener("click", (event) => {
      event.preventDefault();
      setExpandedState(true);
    });

    showLessBtn.addEventListener("click", (event) => {
      event.preventDefault();
      setExpandedState(false);
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  const initCollapsibleContent = (section) => {
    if (!section || !section?.classList.contains("collapsible-content-section"))
      return;

    const toggles = section.querySelectorAll(".collapsible-content__item");

    toggles.forEach((toggle) =>
      toggle.addEventListener("click", (event) =>
        toggleCollapsible(event, toggles)
      )
    );

    initLoadMore(section);
  };

  document.addEventListener(
    "DOMContentLoaded",
    initCollapsibleContent(document.currentScript.parentElement)
  );

  document.addEventListener("shopify:section:load", function (event) {
    initCollapsibleContent(event.target);
  });
})();
